import React from 'react';
import { useApp } from '../../contexts/AppContext';
import SliderInput from './SliderInput';
import { Settings } from 'lucide-react';

const SliderSection: React.FC = () => {
  const { currentInputs, updateCurrentInput } = useApp();

  return (
    <div className="w-full bg-gradient-to-br from-blue-50 via-white to-indigo-50 rounded-2xl p-6 shadow-lg mb-8 border border-blue-100">
      <div className="flex items-center gap-3 mb-5">
        <Settings className="text-blue-600" size={20} />
        <h3 className="text-lg font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
          Schnelleinstellung der wichtigsten Parameter
        </h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <SliderInput
          id="angebotspreis"
          label="Angebotspreis"
          value={currentInputs.angebotspreis}
          min={50000}
          max={1000000}
          step={5000}
          unit="€"
          onChange={(value) => updateCurrentInput('angebotspreis', value)}
        />
        
        <SliderInput
          id="kaltmieteProQm"
          label="SOLL Kaltmiete"
          value={currentInputs.kaltmieteProQm}
          min={5}
          max={30}
          step={0.1}
          unit="€/m²"
          onChange={(value) => updateCurrentInput('kaltmieteProQm', value)}
          forceDecimals={true}
        />
        
        <SliderInput
          id="zinssatz"
          label="Zinssatz"
          value={currentInputs.zinssatz}
          min={0}
          max={10}
          step={0.01}
          unit="%"
          onChange={(value) => updateCurrentInput('zinssatz', value)}
          forceDecimals={true}
        />
        
        <SliderInput
          id="tilgung"
          label="Tilgung"
          value={currentInputs.tilgung}
          min={0}
          max={10}
          step={0.01}
          unit="%"
          onChange={(value) => updateCurrentInput('tilgung', value)}
          forceDecimals={true}
        />
        
        <SliderInput
          id="finanzierungsanteil"
          label="Finanzierung"
          value={currentInputs.finanzierungsanteil}
          min={0}
          max={120}
          step={5}
          unit="%"
          onChange={(value) => updateCurrentInput('finanzierungsanteil', value)}
        />
      </div>
      
      <div className="mt-5 pt-5 border-t border-blue-100">
        <div className="flex items-center justify-between">
          <p className="text-xs text-gray-500">
            💡 Tipp: Nutzen Sie die +/- Buttons für Feineinstellungen oder ziehen Sie den Schieberegler für schnelle Anpassungen
          </p>
          <div className="flex gap-4 text-xs">
            <span className="text-gray-500">IST-Werte: {currentInputs.angebotspreis ? '✓' : '○'}</span>
            <span className="text-gray-500">SOLL-Werte: ✓</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SliderSection;